// extracted by mini-css-extract-plugin
module.exports = {"mainNavigationIcon":"NavigationItems_mainNavigationIcon__2DihM","navListContainer":"NavigationItems_navListContainer__1uXJn","mobileNavList":"NavigationItems_mobileNavList__1A_QI"};